import fetch from 'utils/fetch';

export function registerMerchant(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/registerMerchant',
        method: 'post',
        data
    });
}

export function merchantList(account,shopName,psize) {
    const data = {
        account,
        shopName,
        psize
    };
    return fetch({
        url: '/merchantList',
        method: 'get',
        params:data
    });
}

export function upMerchant(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/upMerchant',
        method: 'put',
        data
    });
}
export function transferAccount(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/transferAccount',
        method: 'post',
        data
    });
}
export function batchDelMerchant(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchDelMerchant',
        method: 'post',
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/merchant.js